import { Tooltip, TooltipProps } from "primereact/tooltip";
import { CSSProperties, ReactNode } from "react";
import { v4 as uuid } from "uuid";

type TooltipWrapperProps = {
  tooltipText: string;
  italics?: boolean;
  tooltipVisible?: boolean;
  children: ReactNode;
  tooltipProps?: TooltipProps;
  maxWidth?: number;
  showDelay?: number;
};

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  tooltipText,
  italics,
  children,
  tooltipProps,
  tooltipVisible = true,
  maxWidth,
  showDelay = 500,
}) => {
  const tooltipId = `tooltip-${uuid()}`;
  const tooltipStyle: CSSProperties = {};
  if (maxWidth) {
    tooltipStyle["maxWidth"] = `${maxWidth}px`;
  }
  if (italics) {
    tooltipStyle["fontStyle"] = "italic";
  }

  return (
    <>
      {tooltipVisible && (
        <Tooltip
          target={`#${tooltipId}`}
          {...tooltipProps}
          style={{ ...tooltipProps?.style, ...tooltipStyle }}
        />
      )}
      <div
        data-pr-tooltip={tooltipText}
        data-pr-showdelay={showDelay}
        id={tooltipId}
        style={{ display: "inline-block" }}
      >
        {children}
      </div>
    </>
  );
};
